import { ListView } from "~/common/wtgn/ListView";
import { Logger } from "~/utils/logger";
const logger = new Logger("list-widget", "info");

export const ListWidget = (props: {
  list: {
    id: string | undefined | null;
    name: string;
  };
  title: string;
  randomize: string;
}) => {
  logger.debug("props", props);

  if (!props.list.id) {
    return <div>No list selected.</div>;
  }

  return (
    <ListView
      title={props.title}
      listId={props.list.id}
      listName={props.list.name}
      randomize={props.randomize === "yes"}
    />
  );
};
